import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrial = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 66 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1988_9102)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14.043 4.915h48.494c.918 0 1.8.458 2.449 1.274C65.636 7.004 66 8.11 66 9.264v8.153c0 1.154-.365 2.26-1.014 3.075-.65.816-1.53 1.274-2.45 1.274H14.044z",
				fill: "#0c0f33"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.13 9.79V8.596h7.114V9.79h-2.868v7.997h-1.382V9.79zm8.686 7.997V8.596h3.276q1.069 0 1.773.368.71.368 1.06 1.019.35.646.35 1.494 0 .844-.355 1.486a2.4 2.4 0 0 1-1.06.992q-.704.354-1.772.354h-2.482v-1.194h2.356q.674 0 1.095-.193.428-.194.624-.56.198-.368.198-.885 0-.52-.202-.902a1.3 1.3 0 0 0-.624-.583q-.421-.207-1.109-.207h-1.741v8.002zm4.538-4.147 2.27 4.147h-1.58L36.82 13.64zm4.995-5.044v9.191h-1.387V8.596zm2.796 9.191h-1.472l3.307-9.191h1.603l3.307 9.191h-1.472l-2.598-7.522h-.072zm.247-3.6h4.775v1.168h-4.775zm7.826 3.6V8.596h1.386v7.997h4.165v1.194z",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.101 4.23c-.465-.025-.807-.43-.72-.87l.527-2.666a.6.6 0 0 0 .018-.127c0-.566-.816-.634-1.877-.634-1.062 0-1.877.076-1.877.634 0 .043 0 .077.017.127l.526 2.648c.088.449-.263.855-.736.872C3.909 4.383.33 5.99.33 8.909v1.125a.55.55 0 0 0 .561.542h9.228c.368 0 .561.262.561.541 0 .22-.158.465-.438.5L3.4 12.893a.503.503 0 0 0-.439.516v2.258c0 4.34 3.518 7.987 8.114 7.987s8.13-3.52 8.13-7.843v-4.729c0-.279.229-.516.562-.516h1.483a.55.55 0 0 0 .56-.541V8.9c0-2.928-3.578-4.417-8.665-4.679z",
				fill: "#fe5800"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1988_9102",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h66v23.872H0z"
		})
	}) })]
});
export default SvgTrial;
